import React from 'react';
import { Box, Button } from '@mui/material';

interface WizardFooterProps {
  /** Disables the Back button (e.g. on the first step). */
  backDisabled: boolean;
  /** Disables the primary button (e.g. while saving). */
  nextDisabled: boolean;
  /** Label for the primary (right-most) button, e.g. "Next" / "Finish" / "Submit for Review". */
  primaryLabel: string;
  /** Secondary button label, shown left of the primary button. Always "Save". */
  secondaryLabel: string;
  /** Disables the secondary button — set while saving and when nothing is dirty. */
  secondaryDisabled: boolean;
  onCancel: () => void;
  onBack: () => void;
  onPrimary: () => void;
  onSecondary: () => void;
}

/**
 * Footer row for the Create/Edit Location wizard card.
 * Close (left) · Back / secondary / primary (right).
 *
 * Actions only — listing-quality guidance lives on the Info step next to the
 * image uploads, where it is actionable and seen once.
 */
const WizardFooter = (props: WizardFooterProps) => {
  const {
    backDisabled,
    nextDisabled,
    primaryLabel,
    secondaryLabel,
    secondaryDisabled,
    onCancel,
    onBack,
    onPrimary,
    onSecondary,
  } = props;

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: { xs: 2, sm: 4 },
        py: 2,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'grey.50',
      }}
    >
      {/* "Close", not "Cancel": each step auto-saves as the user advances, so
          leaving can't undo the steps already persisted. */}
      <Button variant="text" color="inherit" onClick={onCancel}>
        Close
      </Button>

      <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
        <Button variant="outlined" onClick={onBack} disabled={backDisabled}>
          Back
        </Button>
        <Button variant="outlined" onClick={onSecondary} disabled={secondaryDisabled}>
          {secondaryLabel}
        </Button>
        <Button variant="contained" onClick={onPrimary} disabled={nextDisabled}>
          {primaryLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default WizardFooter;

